<app-grid
  *ngIf="(gridColumns$ | async) && (gridOptions$ | async)"
  [data]="gridData"
  [columns]="gridColumns$ | async"
  [options]="gridOptions$ | async"
></app-grid>

<ng-template #addButtonTemplate>
  <app-file-upload-button
    class="uploadButton"
    [isMultiple]="fileUploadConfig.multiple"
    [accept]="fileUploadConfig.accept"
    [sizeLimit]="fileUploadConfig.sizeLimit"
    [imageSizeLimit]="fileUploadConfig.imageSizeLimit"
    [uploadButtonTemplate]="uploadButtonTemplate"
    (filesChange)="onFilesChanged($event)"
  ></app-file-upload-button>
</ng-template>

<ng-template #uploadButtonTemplate let-onAddFiles>
  <button mat-flat-button color="secondary" (click)="onAddFiles()" data-testId="upload-file">
    <mat-icon svgIcon="add"></mat-icon>
    {{addButtonLabel}}
  </button>
</ng-template>

<ng-template #actionsTemplate let-context>
  <div class="d-flex justify-content-end">
    <button
      mat-flat-button
      class="mat-secondary flex-initial button--square mr-2 no-truncate"
      color="primary"
      aria-label="Download"
      matTooltip="Download"
      i18n-aria-label="@@dprDetails.dprAttachmentsGrid.attrDownload"
      i18n-matTooltip="@@dprDetails.dprAttachmentsGrid.attrDownload"
      [disabled]="!isAppOnline"
      (click)="onDownload(context.data)"
      data-testId="download"
    >
      <mat-icon svgIcon="cloud-download"></mat-icon>
    </button>

    <app-delete-button [context]="context"></app-delete-button>
  </div>
</ng-template>
